// extracted by mini-css-extract-plugin
export default {"thumbnail":"_KPXas","overlay":"ga5tQ2","duration":"qFfrzo","duration__background":"kO9o2F","duration__text":"WcuoBy","title":"hRjkkB","play-button":"MmJhNq"};